<template>
    <div>
        <!-- <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div> -->

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >

            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'execution_status'">
                    <a-tag v-if="props.record.execution_status !== '-'"  :color="props.record.execution_status_val == 1? 'green' : 'red'">{{ props.record.execution_status }}</a-tag>
                    <span v-else>{{props.record.execution_status}}</span>
                </div>

                <div v-if="props.column.key == 'pay_status'">
                    <a-tag v-if="props.record.pay_status !== '-'" :color="props.record.pay_status_val == 7? 'red' : props.record.pay_status_val === 0? 'orange' : 'green'">{{ props.record.pay_status }}</a-tag>
                    <span v-else>{{props.record.pay_status}}</span>
                </div>
                
                <div v-if="props.column.key == 'amount'" class="amountBlock" :class="{'amountBlock2':locale == 'zh'}">   
                    <p>
                       <span> {{ $t('invoice.invoiceAmount') }}：</span>
                       {{ props.record.invoice_amount }}
                    </p>
                    <p>
                        <span> {{ $t('financial.realPayAmount') }}：</span>
                        {{ props.record.real_pay_amount }}
                    </p>
                </div>

                <!-- <div v-if="props.column.key == 'instruction'" class="remark">
                    <a-tooltip :content="props.record.instruction">
                        <div class="remark_content" v-if="props.record.remarkIsText">{{ props.record.instruction }}</div>
                    </a-tooltip>
                    
                    <a-input v-if="!props.record.remarkIsText" :style="{width:'200px'}" v-model="props.record.instruction" />
                    <icon-check v-if="!props.record.remarkIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.remarkIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div> -->
            </template>

            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                    <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                    <div class="searchFilter-footer">
                        <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                        <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                    </div>
                    </a-space>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                    <a-button v-permission="'setting.financial.editExecuted'"  type="primary" size="mini"  style="margin-top:5px;width:60px" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
            </template>
        </Table>

        <a-modal
            v-model:visible="visible" 
            width="600px"
            draggable
            popup-container="#modalContainer"
            :onBeforeOk="onBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('financial.confirmExecutionStatusTip') }}</div> 
            </template>

            <div class="field_item">
                <div class="item_label"><span class="required">*</span> {{ $t('financial.executionStatus') }}: </div>
                <a-radio-group v-model="execution_status">
                    <a-radio :value="0">{{ $t('financial.unexecute') }}</a-radio>
                    <a-radio :value="1">{{ $t('financial.executed') }}</a-radio>
                </a-radio-group>
            </div>
            <div  class="field_item">
                <div class="item_label"><span class="required">*</span> {{ $t('financial.confirmDate') }}: </div>
                <a-date-picker style="width: 200px;" v-model="finance_confirm_time" @change="changeDate"/>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { FinancialQuery } from './queryConfig/FinancialQuery.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';

    const localeStore = useLocale()
    const { t } = useI18n()

    const queryForm = reactive(FinancialQuery)
    const showForm = ref(false)
    const sourceObj = ref([])
    const rowData = ref()
    const visible = ref(false)
    const execution_status = ref('')
    const finance_confirm_time = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '序号',
                title:'#',
                dataIndex: 'no',
                key:'no',
                width:'60',
            }, 
            {
                // title: '订单编号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'170',
                filterable: {
                    filter: (value, record) => record.order_name.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '出库单号',
                title:t('invoice.invoiceChildType'),
                dataIndex: 'invoice_child_type',
                key:'invoice_child_type',
                width:'170',
                filterable: {
                    filter: (value, record) => record.invoice_child_type.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            }, 
            {
                // title: '发票号',
                title:t('financial.invoiceNumber'),
                dataIndex: 'invoice_no',
                key:'invoice_no',
                width:'130',
                filterable: {
                    filter: (value, record) => record.invoice_no.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            }, 
            // {
            //     // title: '订单类型',
            //     title:t('order.orderChannelType'),
            //     dataIndex: 'order_channel_type',
            //     key:'order_channel_type',
            //     width:'220',
            //     filterable: {
            //         filter: (value, record) => record.order_channel_type.includes(value),
            //         slotName: 'searchFilter',
            //         icon: () => h(IconSearch)
            //     }
            // },
            // {
            //     // title: '发票类型',
            //     title:t('invoice.invoiceType'),
            //     dataIndex: 'invoice_type',
            //     key:'invoice_type',
            //     width:'130',
            // },
            {
                // title: '执行状态',
                title:t('financial.executionStatus'),
                dataIndex: 'execution_status',
                key:'execution_status',
                width:'170',
                slotName:'slot',
                filterable: {
                    filters: [ 
                        {
                            text: t('financial.unexecute'),
                            value: t('financial.unexecute'),
                        },
                        {
                            text: t('financial.executed'),
                            value: t('financial.executed'),
                        },
                    ],
                    filter: (value, record) => record.execution_status == value,
                    defaultFilteredValue: [t('financial.unexecute')]
                }
            },
            {
                // title: '支付状态',
                title:t('invoice.payStatus'),
                dataIndex: 'pay_status',
                key:'pay_status',
                width:'150',
                slotName:'slot',
                filterable: {
                    filters: [ 
                        {
                            text: t('order.obligation'),
                            value: t('order.obligation'),
                        },
                        {
                            text: t('order.partialPay'),
                            value: t('order.partialPay'),
                        },
                        {
                            text: t('order.pay'),
                            value: t('order.pay'),
                        },
                    ],
                    filter: (value, record) => record.pay_status == value,
                }
            },
            {
                // title: '订单金额',
                title:t('order.amount'),
                dataIndex: 'amount',
                key:'amount',
                width:'220',
                slotName:'slot'
            },
            // {
            //     // title: '备注',
            //     title:t('stock.remark'),
            //     dataIndex: 'instruction',
            //     key:'instruction',
            //     width:'280',
            //     ellipsis:true,
            //     tooltip:true,
            //     slotName:'slot'
            // },
            {
                // title: ' 执行时间',
                title:t('financial.financeConfirmTime'),
                dataIndex: 'finance_confirm_time',
                key:'finance_confirm_time',
                width:'140',
                ellipsis:true,
                tooltip:true,
            },
            // {
            //     // title: '更新时间',
            //     title:t('financial.updateTimestamp'),
            //     dataIndex: 'update_timestamp',
            //     key:'update_timestamp',
            //     width:'130',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '100',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:440,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const payStatus = ref({  // 付款状态
        0:t('order.partialPay'), // 部分付款
        1:t('order.pay'), // 支付
        7:t('order.obligation') // 待付款
    })

    // const showFormPanel = (val)=>{
    //     showForm.value = val
    // }

    // const handleSelectChange = (val,opt,key)=>{
    //     console.log(val,opt,key,'val,opt,key')
    //     queryForm.formData[key] = val
    //     getSEPACollectionList()
    // }

    const handle = (type, row)=>{
        switch(type){
            // case 'search':
            //     getSEPACollectionList()
            //     break;
            // case 'reset':
            //     queryForm.formField.forEach(i=>{
            //         queryForm.formData[i.key] = ''
            //     })

            //     getSEPACollectionList()
            //     break;
            case 'edit':
                visible.value = true
                rowData.value = row
                console.log(row,'rrrr')
                execution_status.value = row.execution_status_val == undefined? '' : row.execution_status_val 
                finance_confirm_time.value = row.execution_status_val == undefined? '' : row.finance_confirm_time
                break;
        }
    }

    // 双击单元格
    // const cellDblClick = (row,column)=>{
    //     // console.log(column,'col')
    //     if(column.key == 'instruction'){
    //         row.remarkIsText = false
    //     }
    // }

    // const cancelSaveComment = (row)=>{
    //     row.remarkIsText = true
    //     getSEPACollectionList()
    // }

    // // 保存备注
    // const saveComment = async (row)=>{
    //     let param = {
    //         instruction:row.instruction,
    //     }
    //     let res = await FinancialApi.getInstance().saveRemarkOverdueList(param,row.id)
    //     if(res.code == 0){
    //         Message.success(t('base.saveSuccess'))
    //         row.remarkIsText = true
    //         getSEPACollectionList()
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    const changeDate = ()=>{
        console.log(finance_confirm_time.value,'finance_confirm_time')
    }

    // 财务确认执行状态
    const onBeforeOk = async (row)=>{
        console.log(execution_status.value,'execution_status')
        if(execution_status.value === ''){
            Message.error(t('financial.executionStatus') +' '+ t('base.noEmpty'))
            return false
        }else if(!finance_confirm_time.value){
            Message.error(t('financial.confirmDate') +' '+ t('base.noEmpty'))
            return false
        }

        let param = {
            execution_status:execution_status.value,  // 0 未执行, 1 已执行
            finance_confirm_time:dateToTimestamp(finance_confirm_time.value),
        }
        let res = await FinancialApi.getInstance().confirmStatusSEPACollection(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            getSEPACollectionList()
        }else{
            Message.error(res.msg)
        }
    }


    // 获取逾期清单列表
    const getSEPACollectionList = async ()=>{
        let param = {
            // ...queryForm.formData
        }
        table.value.configs.loading = true

        let res = await FinancialApi.getInstance().getSEPACollectionList(param)
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.no = index + 1
                item.invoice_no = !item.invoice_no? '-' : item.invoice_no
                item.instruction = item.instruction == ''? '-' : item.instruction
                item.invoice_child_type = !item.invoice_child_type? '-' : item.invoice_child_type
                item.execution_status_val = item.execution_status
                item.execution_status = item.execution_status == 1? t('financial.executed') : t('financial.unexecute')
                item.pay_status_val = item.pay_status
                item.pay_status = !item.pay_status? '-' : payStatus.value[item.pay_status]
                item.invoice_amount = formatMoney(item,'invoice_amount','EUR')
                item.real_pay_amount = formatMoney(item,'real_pay_amount','EUR')
                item.finance_confirm_time = !item.finance_confirm_time? '-' : timestampToDate(item.finance_confirm_time * 1000).split(' ')[0]
                item.update_timestamp = !item.update_timestamp? '-' : timestampToDate(item.update_timestamp * 1000).split(' ')[0]
                item.remarkIsText = true
            })
            table.value.datas = res.data
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    const formatMoney = (item,key, payCurrency)=>{
        return item[key] == undefined? '-' : 
                payCurrency == 'EUR'? '€ ' + Number(item[key]).toFixed(2) : Number(item[key]).toFixed(2)
    }

    // 获取订单来源类型 和 erp客户编码
    // const getOrderSource = async ()=>{
    //     let res = await OrderApi.getInstance().getOrderSource({status:'A'})
    //     if(res.code == 0){
    //         res.data.length > 0 && res.data.forEach(i=>{
    //             sourceObj.value[i.id] = i.id == '1'? 'Shopify' : i.customer_name
    //         })
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = 0 // document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })


    onMounted(()=>{
        // getOrderSource()
        getSEPACollectionList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
// .queryPanel{
//     display: flex;
//     // margin-bottom:7px;
//     padding:7px;
//     background: #fff;
//     border-bottom: 1px dashed #ccc;

//     .queryPanel_form{
//         display: flex;
//         flex:6;
//         flex-direction: column;
//         height: 33px;
//         overflow: hidden;

//         /deep/ .arco-form-layout-inline .arco-form-item{
//             margin-bottom:2px;
//         }
//     }

//     .queryPanel_form_show{
//         height: auto;
//         overflow: visible;
//     }

//     .queryPanel_btn{
//         display: flex;
//         // flex-direction: column;
//         // flex-wrap:wrap;
//         flex: 1;
//         align-items: center;
//         justify-content: center;
//         border-left:1px solid #eee;
//         padding-left:10px;

//         .openBtn{
//             display: inline-block;
//             padding: 3px 10px;
//             margin: 2px 5px 0 5px;
//             width: 80px;
//             text-align: center;
//             color: #165dff;
//             cursor: pointer;
//             border: 1px solid #165dff;
//             border-radius:2px;
//         }
//     }

//     /deep/ .arco-form-item-label-col > .arco-form-item-label{
//         font-size:12px;
//     }

//     /deep/ .arco-form-item-layout-inline{
//         margin-right: 0;
//     }

//     .form_btn{
//         margin:5px 5px 3px;
//         width:90px;
//     }
// }

// /deep/ .operayeBox {
//     margin-bottom: 7px;
//     background: #fff;
//     padding: 5px 24px 5px;
// }

/deep/ .arco-btn-group{
    vertical-align: bottom;
}

/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: -10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-table-td .arco-table-cell{
    padding: 5px 16px !important;
}

/deep/ .table_pagination{
    display: none !important;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

.remark_content{
    cursor: pointer;
}

.amountBlock{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 100px;
        }
    }
}

.field_item{
    margin: 10px 0;
}
.item_label{
    display: inline-block;
    margin-right:20px ;
    width: 200px;
    text-align: right;

    .required{
        color: red;
    }
}


</style>